export const record_operation = {
    ADD: 'add',
    UPDATE: 'update',
    DELETE: 'delete'
}

export const user_roles = {
  ADMINS: 'Admins',
  POWER_USERS: 'Power Users',
  USERS : 'Users',
  SUMMARY_ONLY : 'Summary Only'
}

export const user_roles_source = {
  USERS: 'Users',
  SUMMARY_ONLY: 'Summary Only'
}